import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { CodaltComponent } from '../../../codalt.component';
import { EntitiesService } from '../../../services/entities/entities.service';
import { LocalStorage } from '../../../storage.class';

@Component({
    selector: 'app-trackline-planning-entity-type-dialog',
    standalone: false,
    templateUrl: './trackline-planning-entity-type-dialog.component.html',
    styleUrl: './trackline-planning-entity-type-dialog.component.scss',
})
export class TracklinePlanningEntityTypeDialogComponent extends CodaltComponent {
    private entitiesService = inject(EntitiesService);
    private dialogRef = inject(MatDialogRef<TracklinePlanningEntityTypeDialogComponent>);
    protected readonly activeTypes = LocalStorage.weekplanningTypeFilter;
    protected readonly entities$ = this.entitiesService.getByType(this.environment.planningEntityTypes.map(e => e.key));

    constructor() {
        super();
        if (this.activeTypes?.length === 1) {
            this.entities$.pipe(take(1)).subscribe({
                next: entities => {
                    this.dialogRef?.close(entities.find(e => e.entitytypes[0]?.key === this.activeTypes[0]));
                },
            });
        }
    }
}
